import { BaseOptionType } from 'antd/lib/select';

import { FormItemSelect, Select } from '../../../components/index';
import { useGetRevenueCodesQuery } from '../../../services/revenueCodeApi';
import { RevenueCodeType } from '../../../typesFinancial';

type RevenueCodeSelectProps = {
  required?: boolean;
};

export function RevenueCodeSelect({ required }: RevenueCodeSelectProps) {
  const { data: revenueCodes, isLoading } = useGetRevenueCodesQuery();

  function filterOptionByLabel(input: string, option?: BaseOptionType) {
    return `${option?.label ?? ''}`.toLowerCase().includes(input.toLowerCase());
  }

  function revenueCodeRenderer(revenueCode: Record<string, unknown>) {
    const { id, code, description, name } = revenueCode as RevenueCodeType;
    return (
      <Select.Option key={id} value={id} label={name}>
        <div style={{ display: 'flex', gap: '12px', whiteSpace: 'normal' }}>
          <span
            style={{
              flex: '0 0 auto',
              minWidth: '64px',
              fontFamily: 'Consolas',
              fontWeight: 700,
            }}
          >
            {code}
          </span>
          <span style={{ wordBreak: 'break-word' }}>{description}</span>
        </div>
      </Select.Option>
    );
  }

  return (
    <FormItemSelect
      name="revenue_code"
      label="Despesa/Receita"
      dataList={revenueCodes}
      optionRenderer={revenueCodeRenderer}
      optionLabelProp="label"
      showSearch
      filterOption={filterOptionByLabel}
      isLoading={isLoading}
      required={required}
    />
  );
}
